import React, { useEffect, useState } from "react";
import { FaMoon, FaSun } from "react-icons/fa";

export default function ThemeToggle() {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("theme");
    if (saved === "dark") {
      document.documentElement.classList.add("dark");
      setDark(true);
    }
  }, []);

  const toggleTheme = () => {
    const next = !dark;
    setDark(next);

    if (next) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className="h-12 w-12 rounded-full flex items-center justify-center
      bg-white/80 dark:bg-[#0b0b12]/80
      border border-black/10 dark:border-white/15
      shadow-md backdrop-blur-xl"
      aria-label="Toggle theme"
      title="Toggle theme"
    >
      {dark ? <FaSun /> : <FaMoon />}
    </button>
  );
}
